import React from 'react';

const GoalProgressCard = ({ title, count, icon }) => {
  return (
    <div className="card flex flex-col items-center justify-center text-center">
      <div className="h-12 w-12 rounded-full bg-primary-light bg-opacity-10 flex items-center justify-center text-primary">
        {icon}
      </div>
      <h3 className="mt-4 text-lg font-medium text-gray-900">{title}</h3>
      <div className="mt-2 text-3xl font-semibold">{count}</div>
      <p className="mt-1 text-sm text-gray-500">
        {count === 1 ? 'session' : 'sessions'} completed
      </p>
    </div>
  );
};

export default GoalProgressCard; 